import { render } from "./Home.vue?vue&type=template&id=e2d86516"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=e2d86516&lang=css"
script.render = render

export default script